import { Controller } from '@hotwired/stimulus'

const FEEDBACK_TIMEOUT = 2000 // ms

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ['button', 'successFeedback', 'clipboardIcon']
  static values = {
    text: String,
    successText: String
  }

  copy (event) {
    event.preventDefault()

    navigator.clipboard.writeText(this.textValue).then(() => {
      if (this.hasSuccessTextValue && this.hasButtonTarget) {
        this.buttonTarget.textContent = this.successTextValue
      } else if (this.hasSuccessFeedbackTarget && this.hasClipboardIconTarget) {
        this.toggleFeedback()
        setTimeout(() => {
          this.toggleFeedback()
        }, FEEDBACK_TIMEOUT)
      }
    })
  }

  toggleFeedback () {
    this.clipboardIconTarget.toggleAttribute('hidden')
    this.successFeedbackTarget.toggleAttribute('hidden')
  }
}
